import { useEffect, useState } from 'react';
import Select, { createFilter } from 'react-select';
import { FONT } from "../../value/staticValues";

interface CustomDropDownProps {
    width?: number;
    height?: number;
    placeholder?: string;
    items: DropdownType[];
    setValue: Function;
    value?: string;
    defaultvalue?: DropdownType;
    disable?: boolean;
}

export interface DropdownType {
    label: string;
    value: string;
}

export function CustomDropDown(props:CustomDropDownProps) {
    const initItemLabel = "Loading...";
    const [selectItem, setSelectItem] = useState<DropdownType>({label: initItemLabel, value: ""});
    const [activeYn, setActiveYn] = useState(props.disable);

    useEffect(() => {
        if(props.setValue && selectItem.label !== initItemLabel){
            props.setValue(selectItem.value);
        }
    }, [selectItem]);

    const styles= {
        base: (base:any) => ({
            ...base,
            borderWidth: 0,
        }),
        placeholder: (base:any, state:any) => ({
            ...base,
            fontFamily: FONT.REGULAR,
            fontSize: 12,
            color: state.isDisabled? "#a6a6a6" : "#333",
        }),
        option: (base:any, state:any) => ({
            ...base,
            minHeight:32,
            marginTop: 1.5, marginBottom: 1.5,
            backgroundColor: state.isSelected || state.isFocused ? "#f2f4f7" : "#fff",
            borderRadius: 5,
            fontFamily: FONT.REGULAR,
            fontSize: 12,
            color: "#333"
        }),
        menu: (base:any) => ({
            ...base,
            width: props.width, minWidth: 140, 
            margin: 0,
            borderRadius: 4,
            backgroundColor: "#fff",
        }),
        menuList: (base:any, state:any) => ({
            ...base,
            width: props.width, minWidth: 140, 
            marginTop: 2,
            padding: 4,
            borderRadius: 4,
            boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.15)",
            backgroundColor: "#fff",
        }),
        control: (base:any, state:any) => ({
            ...base,
            width: props.width, minWidth: 140, 
            height: props.height || 36,
            paddingLeft: 11,
            borderRadius: 4,
            boxShadow: state.isFocused ? null : null,
            borderColor: "#d2d5d9", borderWidth: 0.8,
            backgroundColor: state.isDisabled? "#f0f0f0" : "#fff",
            fontFamily: FONT.REGULAR,
            fontSize: 12,
            color: state.isDisabled? "#a6a6a6" : "#333",
            '&:hover': {
                borderColor: "rgba(99, 122, 255, 0.8)",
            }
        }),
        dropdownIndicator: (base:any, state:any) => ({
            ...base,
            transform: state.selectProps.menuIsOpen && 'rotate(180deg)'
        }),

    }
    return (
        <Select 
            options={props.items}
            defaultValue={props.defaultvalue?.label ? props.defaultvalue : null}
            placeholder={props.placeholder || ''}
            value={props.value? 
                props.items.filter((item) => {
                    if(item.value === props.value) {
                        return ({
                            label: item.label,
                            value: item.value
                        })
                    }
                    // return item.value === props.value
                })
            : undefined }
            isClearable={false}
            isSearchable={false}
            isDisabled={props.disable}
            menuPortalTarget={document.body}
            menuShouldBlockScroll={true}
            menuPosition={"fixed"}
            styles={styles}
            onChange={(r:any) => {
                props.setValue(r.value)
            }}
            components={{
                IndicatorSeparator: () => null,
            }}
        />
    )
}
